import React from "react";
import { UserPaymentTrancheApi } from "api";
import { PaziaBadge, PaziaMenu } from "components/atoms";
import { REGISTRATION_TRANCHE_PAYMENT_STATUSES, REGISTRATION_TRANCHE_PAYMENT_STATUSES_LABELS } from "consts";
import { daysToDate, formatDate, toMoneyFormat } from "utils";
import { getTrancheActions, PAYMENT_STATUSES_BADGE_LABELS_COLORS } from "./StudentPaymentsTrancheRow";

interface StudentPaymentsTrancheCardProps {
  tranche: UserPaymentTrancheApi;
  onPostponePayment: (courseTrancheId: number) => void;
  setEditStatusPayment: (tranche: UserPaymentTrancheApi) => void;
  setEditPricePayment: (tranche: UserPaymentTrancheApi) => void;
  onGeneratePaymentLink: (tranche: UserPaymentTrancheApi) => void;
  onEditTranche: (tranche: UserPaymentTrancheApi) => void;
}

export const StudentPaymentsTrancheCard = (props: StudentPaymentsTrancheCardProps) => {
  const { tranche } = props;
  const actions = getTrancheActions(props);
  const days = daysToDate(new Date(tranche.dueDate));
  const isOverdue = days < 0;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3.5 dark:border-slate-700 dark:bg-slate-900">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-slate-900 dark:text-slate-100">{tranche.name}</div>
          <div className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">#{tranche.courseTrancheId}</div>
        </div>
        <PaziaBadge color={PAYMENT_STATUSES_BADGE_LABELS_COLORS[tranche.status]} size="xs">
          {REGISTRATION_TRANCHE_PAYMENT_STATUSES_LABELS[tranche.status]}
        </PaziaBadge>
      </div>

      <div className="mt-3 flex items-end justify-between gap-2">
        <div>
          <div className="text-xs text-slate-500 dark:text-slate-400">
            Termin: {formatDate(new Date(tranche.dueDate))}
          </div>
          {tranche.status !== REGISTRATION_TRANCHE_PAYMENT_STATUSES.PAID_BY_USER && (
            <div
              className={`text-sm font-medium ${isOverdue ? "text-red-600 dark:text-red-400" : "text-primary-600 dark:text-primary-400"}`}
            >
              {isOverdue ? `${Math.abs(days)} dni po terminie` : `za ${days} dni`}
            </div>
          )}
        </div>
        <div className="text-right">
          {tranche.amount !== tranche.discountedAmount && (
            <div className="text-xs text-slate-500 line-through dark:text-slate-400">
              {toMoneyFormat(tranche.amount, true)}
            </div>
          )}
          <div className="font-semibold text-slate-900 dark:text-slate-100">
            {toMoneyFormat(tranche.discountedAmount, true)}
          </div>
        </div>
      </div>

      <div className="mt-3 flex justify-end border-t border-slate-100 pt-2.5 dark:border-slate-800">
        <PaziaMenu title="Zarządzaj" actions={actions} />
      </div>
    </div>
  );
};
